import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/PropertyListingPageBlock/Component.tsx");
